const CHANNEL5_HOSTNAME = 'channel5.com';

const isChannel5Host = (): boolean => {
    const hostname = window?.location?.hostname ?? '';
    return hostname.includes(CHANNEL5_HOSTNAME);
};

const getDomain = (): string => (isChannel5Host() ? `.${CHANNEL5_HOSTNAME}` : '');

interface CookieOptions {
    /** Expiry time in minutes */
    expiresInMinutes?: number;
    /** Cookie path, defaults to '/' */
    path?: string;
    /** Cookie domain, defaults to .channel5.com (empty on localhost) */
    domain?: string;
}

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
    const { expiresInMinutes, path = '/', domain = getDomain() } = options;
    let cookie = `${name}=${encodeURIComponent(value)};path=${path}`;

    if (expiresInMinutes) {
        const expires = new Date(Date.now() + expiresInMinutes * 60 * 1000).toUTCString();
        cookie += `;expires=${expires}`;
    }

    if (domain) {
        cookie += `;domain=${domain}`;
    }

    document.cookie = cookie;
};

export const getCookie = (name: string): string => {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
};

export const removeCookie = (name: string, options: Pick<CookieOptions, 'path' | 'domain'> = {}): void => {
    setCookie(name, '', { ...options, expiresInMinutes: -1 });
};

export const hasCookie = (name: string): boolean => !!getCookie(name);
